<template>
    <ul  class="fixed-box">
        <li @mouseover="kehuduan=true" @mouseleave="kehuduan=false" class="p-pointer">
            <svg class="icon" aria-hidden="true"  v-show="kehuduan">
                <use xlink:href="#iconkehuduan1"></use>
            </svg>
            <svg class="icon" aria-hidden="true"  v-show="!kehuduan">
                <use xlink:href="#iconkehuduan"></use>
            </svg>
            <div class="fixed-left" v-show="kehuduan">
                <ul>
                    <li>
                        <img :src="qrCodeSrc + 'SJ_APP_ios.png'">
                        <h4>ios</h4>
                        <span>掃壹掃，隨時隨地學習</span>
                    </li>
                    <li>
                        <img :src="qrCodeSrc + 'SJ_APP_android.png'">
                        <h4>Android</h4>
                        <span>掃壹掃，隨時隨地學習</span>
                    </li>
                </ul>
            </div>
        </li>
        <li @mouseover="top=true" @mouseleave="top=false" class="p-pointer" @click="fixedTopClick">
            <svg class="icon" aria-hidden="true" v-show="top">
                <use xlink:href="#icontop"></use>
            </svg>
            <svg class="icon" aria-hidden="true" v-show="!top">
                <use xlink:href="#icontop1"></use>
            </svg>
        </li>
    </ul>
</template>
<script>
import config from '@/config'

export default {
    data(){
        return {
            top:false,
            kehuduan:false,
            qrCodeSrc: config.qrCodeSrc,
        }
    },
    methods:{
        fixedTopClick(){
            const timer = setInterval(function () {
                let osTop = document.documentElement.scrollTop || document.body.scrollTop
                let ispeed = Math.floor(-osTop / 2)
                document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed
                this.isTop = true
                if (osTop === 0) {
                    clearInterval(timer)
                }
            },30)

        }
    },
}
</script>
<style scoped>

</style>

<style lang="less" scoped>
    .fixed-box{
        width: 26px;
        height: 109px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(234,234,243,1);
        position: fixed;
        right: 42px;
        bottom: 142px;
        padding: 0 14px;
        z-index: 20;
        >li{
            display: flex;
            // justify-content: center;
            align-items: center;
            height: 50%;
            font-size: 24px;
        }
        >li:nth-child(1){
            border-bottom:1px solid rgba(234,234,243,1);
            position: relative;
            >.fixed-left{
                position: absolute;
                left: -206px;
                top: -240px;
                z-index: 10;
                ul{
                    width: 132px;
                    height: 349px;
                    padding: 0 24px;
                    background:rgba(255,255,255,1);
                    border:1px solid rgba(234,234,243,1);
                    box-shadow:0px 3px 6px rgba(51,51,51,0.1);
                    li{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-flow: column;
                        height: 50%;
                        img{
                            width: 80px;
                            color: #000000;
                        }
                        h4{
                            font-size:14px;
                            color:rgba(77,142,246,1);
                            margin: 8px 0;
                        }
                        span{
                            font-size:12px;
                            color:rgba(51,51,51,0.50);
                        }
                    }
                    li:nth-child(1){
                        border-bottom:1px dashed rgba(234,234,243,1);
                    }
                }
            }
        }
    }
</style>
